import { IParams } from '../params';

export const commercialParams: (keyof IParams)[] = [
  'publishPeriod',
  'video',
  'withPhoto',
  'activityField',
  'buildingPurpose',
  'buildingType',
  'buildingClass',
  'buildingClassWarehouse',
  'placementType',
  'houseLineShoppingArea',
  'propertyType',
  'estateType',
  'houseLineBuilding',
  'houseYear',
  'floor',
  'floorsTotal',
  'accessSystem',
  'entrance',
  'contract',
  'ceilingHeight',
  'officeCondition',
  'manufactureCondition',
  'buildingCondition',
  'furniture',
  'equipment',
  'garageKind',
  'garageType',
  'garageMaterial',
  'garageStatus',
  'garageFacilities',
  'parking',
  'buildingElevator',
  'buildingCrane',
  'buildingGates',
  'buildingHeating',
  'infrastructure',
  'undergroundTime',
  'comission',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
  'amenities',
];
